import { render } from "./UomoLoginCustom.vue?vue&type=template&id=35f37c17&scoped=true&ts=true"
import script from "./UomoLoginCustom.vue?vue&type=script&lang=ts"
export * from "./UomoLoginCustom.vue?vue&type=script&lang=ts"

import "./UomoLoginCustom.vue?vue&type=style&index=0&id=35f37c17&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2728993903/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f37c17"]])

export default __exports__